export default "__VITE_ASSET__37a9a7b0__"